import { BuildUri } from "./BuildUri";

import { NetworkManager } from "../context";
import { File } from "../model/File";
import { FileUploadRequest } from "../requests/FileUploadRequest";

class AttachmentEndpoints {
    uploadFile(attachmentLogId: number, request: FileUploadRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/attachment/{attachmentLogId}", {attachmentLogId}),
            {
                method: "POST",
                body: request
            }
        );
    }

    downloadFile(fileId: number): Promise<Response> {
        return NetworkManager.fetch(
            BuildUri("/attachment/file/{fileId}", { fileId })
        );
    }

    discardFile(fileId: number): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/attachment/file/{fileId}", { fileId }),
            { method: "DELETE" }
        );
    }
}

export default new AttachmentEndpoints();